CardMemberMenuView = require 'views/member-menu-profile/card-member-menu-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
template = require 'views/templates/member_on_card'

module.exports = class CardViewHelpers

  openMemberOnCardMenu: (e) ->
    Util.stop(e)

    elem = @$(e.target).closest('.member')
    idMem = elem.attr("data-idmem")
    member = @modelCache.get('Member', idMem)
    card = @model

    PopOver.toggle
      elem: elem
      view: CardMemberMenuView
      options: { model: member, @modelCache, card }

    return

  getMemberOnCardHtml: (member) ->
    data = member.toJSON()

    board = @model.getBoard()
    data.isVirtual = board.getOrganization()?.isVirtual(member) || board.isVirtual(member)
    data.isDeactivated = board.isDeactivated(member)

    template(data)



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-view-helpers.coffee